import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { GraduationCap } from 'lucide-react';

interface DegreeCardProps {
  degree: Degree;
  isEnrolled: boolean;
  progress?: number;
}

export const DegreeCard: FC<DegreeCardProps> = ({ degree, isEnrolled, progress }) => {
  const navigate = useNavigate();
  const hasImage = degree.image?.url;

  const handleCardClick = () => {
    navigate({
      to: '/degrees/$degreeId',
      params: { degreeId: degree.id.toString() },
    });
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-(--neutral-white-NW1000) rounded-2xl! overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer flex flex-col h-full"
    >
      <div className="relative h-48 shrink-0">
        {hasImage ? (
          <img src={degree.image?.url} alt={degree.name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-linear-to-br from-gray-700 to-gray-900 flex items-center justify-center">
            <GraduationCap className="w-20 h-20 text-gray-400" />
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span className="inline-block px-3 py-1 bg-(--secondary-B900) text-(--neutral-white-NW1000) [font-size:var(--fs-l5)] font-semibold rounded-full">
            Education
          </span>
        </div>
      </div>

      <div className="p-6 flex flex-col flex-1 justify-between gap-4">
        <div className="flex flex-col gap-4">
          <h3 className="[font-size:var(--fs-p3)] lg:[font-size:var(--fs-p2)] font-bold text-(--neutral-black-NB800)! leading-tight line-clamp-2 m-0!">
            {degree.name}
          </h3>

          <p className="[font-size:var(--fs-l4)] leading-tight text-(--neutral-black-NB800)! line-clamp-3 m-0!">
            {degree.shortDescription}
          </p>

          {isEnrolled && progress !== undefined && (
            <div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-(--success-S600) h-2 rounded-full transition-all"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <div className="flex items-center justify-between [font-size:var(--fs-l4)]">
                <span className="text-(--success-S600) font-semibold">
                  {progress} percent complete
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
